import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const FinanceHubCustomerListItemFieldsFragmentDoc = gql`
  fragment FinanceHubCustomerListItemFields on FinanceHubCustomerListItem {
    account_id
    address
    chat_id
    currency_code
    customer_name
    has_autopay
    has_contact_info
    has_payment_method
    has_payment_plan
    has_statement
    invoice_count
    outstanding_balance_in_micros
  }
`;
export const FinanceHubCustomerListDocument = gql`
  query FinanceHubCustomerList($limit: Int) {
    getFinanceHubCustomerList(limit: $limit) {
      customers {
        ...FinanceHubCustomerListItemFields
      }
    }
  }
  ${FinanceHubCustomerListItemFieldsFragmentDoc}
`;
export function useFinanceHubCustomerListQuery(
  baseOptions?: Apollo.QueryHookOptions<
    Types.FinanceHubCustomerListQuery,
    Types.FinanceHubCustomerListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.FinanceHubCustomerListQuery,
    Types.FinanceHubCustomerListQueryVariables
  >(FinanceHubCustomerListDocument, options);
}
export function useFinanceHubCustomerListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.FinanceHubCustomerListQuery,
    Types.FinanceHubCustomerListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.FinanceHubCustomerListQuery,
    Types.FinanceHubCustomerListQueryVariables
  >(FinanceHubCustomerListDocument, options);
}
export type FinanceHubCustomerListQueryHookResult = ReturnType<
  typeof useFinanceHubCustomerListQuery
>;
export type FinanceHubCustomerListLazyQueryHookResult = ReturnType<
  typeof useFinanceHubCustomerListLazyQuery
>;
export type FinanceHubCustomerListQueryResult = Apollo.QueryResult<
  Types.FinanceHubCustomerListQuery,
  Types.FinanceHubCustomerListQueryVariables
>;

/**
 * Wrapped version of useGeneratedFinanceHubCustomerListQuery using Pepper's useWrappedQuery
 */
export function useGeneratedFinanceHubCustomerListQuery(
  options?: Apollo.QueryHookOptions<
    Types.FinanceHubCustomerListQuery,
    Types.FinanceHubCustomerListQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.FinanceHubCustomerListQuery,
    Types.FinanceHubCustomerListQueryVariables
  >(FinanceHubCustomerListDocument, options);
}

/**
 * Wrapped version of useGeneratedFinanceHubCustomerListLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedFinanceHubCustomerListLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.FinanceHubCustomerListQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.FinanceHubCustomerListQuery,
    Types.FinanceHubCustomerListQueryVariables
  >(FinanceHubCustomerListDocument, lazyOptions);
}
